import React from 'react';

export default function CGVPage() {
    return (
        <div className="cgv-page" style={{ padding: '60px 20px', maxWidth: '800px', margin: '0 auto', fontFamily: 'Inter, sans-serif', lineHeight: '1.6' }}>
            <h1 style={{ fontSize: '2.5rem', marginBottom: '40px', textAlign: 'center', fontWeight: 'bold' }}>Conditions Générales de Vente (CGV)</h1>

            <div style={{ color: '#4b5563', marginBottom: '30px', fontStyle: 'italic' }}>
                Dernière mise à jour : {new Date().toLocaleDateString('fr-FR')}
            </div>

            <section style={{ marginBottom: '40px' }}>
                <h2 style={{ fontSize: '1.5rem', fontWeight: 'bold', marginBottom: '20px', color: '#111827' }}>1. Objet</h2>
                <p>
                    Les présentes Conditions Générales de Vente (CGV) régissent les relations contractuelles entre la société <strong>INFOCOLAB</strong> (ci-après "le Prestataire")
                    et toute personne physique ou morale (ci-après "le Client") souhaitant bénéficier des services proposés par le Prestataire (création de sites web, développement d'applications, maintenance, etc.).
                </p>
            </section>

            <section style={{ marginBottom: '40px' }}>
                <h2 style={{ fontSize: '1.5rem', fontWeight: 'bold', marginBottom: '20px', color: '#111827' }}>2. Services</h2>
                <p>
                    Le Prestataire s'engage à fournir les services détaillés dans le devis accepté par le Client. Ces services peuvent inclure la conception, le développement, l'intégration,
                    le référencement, la maintenance et l'hébergement de solutions web. Toute prestation non mentionnée explicitement dans le devis fera l'objet d'une facturation supplémentaire.
                </p>
            </section>

            <section style={{ marginBottom: '40px' }}>
                <h2 style={{ fontSize: '1.5rem', fontWeight: 'bold', marginBottom: '20px', color: '#111827' }}>3. Prix et Modalités de Paiement</h2>
                <p>
                    Les prix des services sont indiqués en euros et sont ceux en vigueur au moment de l'acceptation du devis. Ils sont majorés de la TVA au taux en vigueur, sauf mention contraire.
                </p>
                <p style={{ marginTop: '10px' }}>
                    Sauf accord spécifique, les modalités de paiement sont les suivantes :
                </p>
                <ul style={{ listStyleType: 'disc', paddingLeft: '20px', marginTop: '10px' }}>
                    <li>Un acompte est exigible à la signature du devis (généralement 30% ou 50%).</li>
                    <li>Le solde est payable à la livraison ou selon un calendrier défini (paiement échelonné).</li>
                </ul>
                <p style={{ marginTop: '10px' }}>
                    En cas de retard de paiement, des pénalités de retard seront appliquées conformément à la législation en vigueur.
                </p>
            </section>

            <section style={{ marginBottom: '40px' }}>
                <h2 style={{ fontSize: '1.5rem', fontWeight: 'bold', marginBottom: '20px', color: '#111827' }}>4. Obligations du Client</h2>
                <p>
                    Le Client s'engage à fournir au Prestataire toutes les informations et éléments nécessaires (textes, images, accès) pour la bonne réalisation de la prestation dans les délais impartis.
                    Le Client certifie être titulaire des droits de propriété intellectuelle sur les éléments fournis.
                </p>
            </section>

            <section style={{ marginBottom: '40px' }}>
                <h2 style={{ fontSize: '1.5rem', fontWeight: 'bold', marginBottom: '20px', color: '#111827' }}>5. Propriété Intellectuelle</h2>
                <p>
                    Le Prestataire conserve la propriété intellectuelle des créations jusqu'au paiement intégral du prix. Une fois le paiement effectué, les droits d'exploitation (utilisation, modification)
                    sont cédés au Client pour la durée de protection des droits d'auteur, sauf mention contraire pour des éléments spécifiques (licences tierces, code propriétaire).
                </p>
            </section>

            <section style={{ marginBottom: '40px' }}>
                <h2 style={{ fontSize: '1.5rem', fontWeight: 'bold', marginBottom: '20px', color: '#111827' }}>6. Responsabilité</h2>
                <p>
                    Le Prestataire est tenu à une obligation de moyens. Sa responsabilité ne saurait être engagée pour des dommages indirects, pertes de données ou interruptions de service indépendantes de sa volonté (hébergeur, attaques informatiques).
                    En tout état de cause, la responsabilité du Prestataire est limitée au montant de la prestation facturée.
                </p>
            </section>

            <section style={{ marginBottom: '40px' }}>
                <h2 style={{ fontSize: '1.5rem', fontWeight: 'bold', marginBottom: '20px', color: '#111827' }}>7. Résiliation</h2>
                <p>
                    En cas de manquement grave de l'une des parties à ses obligations, le contrat pourra être résilié de plein droit après mise en demeure restée infructueuse.
                    En cas d'annulation par le Client en cours de projet, l'acompte versé reste acquis au Prestataire et les travaux déjà réalisés seront facturés.
                </p>
            </section>

            <section style={{ marginBottom: '40px' }}>
                <h2 style={{ fontSize: '1.5rem', fontWeight: 'bold', marginBottom: '20px', color: '#111827' }}>8. Loi Applicable et Juridiction</h2>
                <p>
                    Les présentes CGV sont soumises au droit français. En cas de litige, les parties s'efforceront de trouver une solution amiable.
                    À défaut, le litige sera porté devant les tribunaux compétents du ressort du siège social du Prestataire.
                </p>
            </section>
        </div>
    );
}
